export default class SectionType {
  static assign (item) {
    const sectionType = Object.assign(new SectionType(), {
      code: item.code,
      orderNum: item.orderNum,
      options: item.options,
      displayName: item.displayName,
      disabled: item.disabled,
      description: item.description,
      _src: item
    })
    return sectionType
  }
}
